import { api } from './auth.service';

const negocioQuantificacaoService = {
  // Obter quantificação. Se passar versao, retorna a versão específica.
  // Sem versao, retorna a maior (atual).
  obter: async (negocioId, usuarioId, versao = null) => {
    const res = await api.get(`/quantificacao/negocio/${negocioId}`, {
      params: {
        usuario_id: usuarioId || undefined,
        versao: versao || undefined,
      },
    });
    return res.data;
  },

  // Lista todas as versões existentes de quantificação pro negócio
  listarVersoes: async (negocioId, usuarioId) => {
    const res = await api.get(`/quantificacao/negocio/${negocioId}/versoes`, {
      params: { usuario_id: usuarioId || undefined },
    });
    return res.data;
  },

  // Cria uma nova versão de quantificação (incrementa versao + copia cabeçalho)
  // Se anexo_id for informado, vincula o anexo DOS010 à nova versão
  criarNovaVersao: async (negocioId, dados) => {
    const res = await api.post(`/quantificacao/negocio/${negocioId}/nova-versao`, dados);
    return res.data;
  },

  // Salvar quantificação (substitui cabeçalho e itens da versão informada)
  // Se versao não vier no payload, backend usa a maior existente
  salvar: async (negocioId, dados) => {
    const res = await api.post(`/quantificacao/negocio/${negocioId}`, dados);
    return res.data;
  },

  // Parsear PDF do DOS010 anexado (extrai tópicos/subtópicos)
  parsear: async (negocioId, anexoId, usuarioId) => {
    const res = await api.get(`/quantificacao/parsear/${negocioId}/${anexoId}`, {
      params: { usuario_id: usuarioId || undefined },
    });
    return res.data;
  },
};

export default negocioQuantificacaoService;
